export interface SectionTitleProps {
  label: string;
  title: string;
  centered?: boolean;
  delay?: number;
  dark?: boolean;
}

export default function SectionTitle({
  label,
  title,
  centered = true,
  delay = 100,
  dark = false,
}: SectionTitleProps) {
  const alignment = centered ? 'text-center' : 'text-left';
  const subColor = dark ? 'text-[#00A8B5]/90' : 'text-[#00A8B5]';
  const lineColor = dark ? 'bg-[#00A8B5]/50' : 'bg-[#00A8B5]';

  return (
    <div className={`${alignment} mb-12 sm:mb-16 animate-fade-in-up delay-${delay}`}>
      {/* Title */}
      <h2
        className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight leading-none mb-4"
      >
        {title}
      </h2>

      {/* Decorative line */}
      <div className="flex items-center justify-center gap-3">
        <div className={`h-px w-10 sm:w-12 ${lineColor} opacity-40`}></div>
        <div className="w-1.5 h-1.5 rounded-full bg-[#00A8B5]"></div>
        <div className={`h-px w-10 sm:w-12 ${lineColor} opacity-40`}></div>
      </div>
    </div>
  );
}